import React from 'react';
import PropTypes from 'prop-types';
import EditSecuritiesSnapshotTable from './EditSecuritiesSnapshotTable';
import EditSecuritiesSnapshotForm from './EditSecuritiesSnapshotForm';
import {
  MotifModal,
  MotifButton,
  MotifLabel,
  MotifToggleSwitch,
} from '@ey-xd/motif-react';
import SecuritiesSnapshotHeader from '../../components/reits/SecuritiesSnapshotHeader';
import UploadQuarterlySecurityModal from '../../components/SecuritiesQuarterly/UploadQuarterlySecurityModal';
const editSecuritiesSnapshotComponent = ({
  securitiesSnapshots,
  showForm,
  handleCloseForm,
  handleSubmit,
  formPurpose,
  selectedSecuritiesSnapshot,
  handleEditButtonClick,
  canEdit,
  handleDismissErrorMessage,
  isTenPercentValueTestDisabledFlag,
  handleDisableTenPercentValueTestSelection,
  handleHideZeroBalanceRows,
  hideZeroBalanceRows,
  handleExportSecuritiesQuarterlyData,
  handleUploadSecuritiesQuarterlyData,
  showQuarterlyUploadSecuritiesModal,
  toggleQuarterlyUploadSecuritiesModal,
}) => {
  const initialValues = {
    ownedSharesValue: '0.00',
    percentOfVote: '0.00',
  };
  return (
    <div className="edit-securitiesSnapshot-component">
      <div className="row">
        <div className="pl-0 pr-0 col-md-12 d-flex">
          <div className="col-md-10">
            <h2>Securities Snapshot {canEdit ? '' : '- Testing Closed'} </h2>
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center ml-3">
        {/* Empty div to push everything to the right */}
        <div className="flex-grow-1" />

        <div
          className="d-flex align-items-center mr-4"
          style={{ marginTop: '10px' }}
        >
          <MotifLabel
            htmlFor="switchZeroBalanceRows"
            className="mb-0 mr-2"
            style={{
              whiteSpace: 'nowrap',
              fontSize: '14px',
            }}
          >
            Hide Zero Balance System Securities:
          </MotifLabel>
          <MotifToggleSwitch
            aria-label="Hide Zero Balance toggle"
            name="switchZeroBalanceRows"
            id="switchZeroBalanceRows"
            data-testid="tglHideZeroBalanceRows"
            onChange={handleHideZeroBalanceRows}
            checked={!!hideZeroBalanceRows}
          />
        </div>

        <div>
          <SecuritiesSnapshotHeader
            handleExportSecuritiesQuarterlyData={
              handleExportSecuritiesQuarterlyData
            }
            handleUploadSecuritiesQuarterlyData={
              handleUploadSecuritiesQuarterlyData
            }
          />
          {showQuarterlyUploadSecuritiesModal && (
            <UploadQuarterlySecurityModal
              show={showQuarterlyUploadSecuritiesModal}
              onClose={toggleQuarterlyUploadSecuritiesModal}
            />
          )}
        </div>
      </div>
      <div>
        <EditSecuritiesSnapshotTable
          securitiesSnapshots={securitiesSnapshots}
          showForm={showForm}
          handleEditButtonClick={handleEditButtonClick}
          hideZeroBalanceRows={hideZeroBalanceRows}
          canEdit={canEdit}
        />
      </div>
      <MotifModal
        size="lg"
        variant="alt"
        show={showForm}
        area-label="Add or Edit Snapshot"
        onClose={handleCloseForm}
        data-testid="AddEditSnapshotModal"
      >
        <EditSecuritiesSnapshotForm
          onSubmit={handleSubmit}
          handleCloseForm={handleCloseForm}
          initialValues={selectedSecuritiesSnapshot}
          formPurpose={formPurpose}
          selectedSecuritiesSnapshot={selectedSecuritiesSnapshot}
          handleDismissErrorMessage={handleDismissErrorMessage}
          isTenPercentValueTestDisabledFlag={isTenPercentValueTestDisabledFlag}
          handleDisableTenPercentValueTestSelection={
            handleDisableTenPercentValueTestSelection
          }
        />
      </MotifModal>
    </div>
  );
};

editSecuritiesSnapshotComponent.propTypes = {
  securitiesSnapshots: PropTypes.arrayOf(
    PropTypes.shape({
      allSharesFromIssuerValue: PropTypes.number,
      class: PropTypes.string,
      securitiesSnapshotID: PropTypes.number,
      issuer: PropTypes.string,
      securityName: PropTypes.string,
      reitOwnedSharesValue: PropTypes.number,
      percentOfVote: PropTypes.number,
      reportPeriodID: PropTypes.number,
      reitOrPropertyName: PropTypes.string,
      clientAccountCode: PropTypes.string,
      isTenPercentValueTestDisabled: PropTypes.bool,
    })
  ),
  showForm: PropTypes.bool,
  handleCloseForm: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  formPurpose: PropTypes.string,
  selectedSecuritiesSnapshot: PropTypes.object,
  handleEditButtonClick: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  handleDismissErrorMessage: PropTypes.func,
  handleHideZeroBalanceRows: PropTypes.func.isRequired,
  hideZeroBalanceRows: PropTypes.bool,
};

export default editSecuritiesSnapshotComponent;
